{
  "courses": {
    "title": "Kurser & Utbildning",
    "createButton": "Ny kurs",
    "createStudentButton": "Ny student",
    "createTitle": "Skapa kurs",
    "editTitle": "Redigera kurs",
    "backToList": "Tillbaka till kurser",
    "searchPlaceholder": "Sök på titel eller plats...",
    "allStatuses": "Alla statusar",
    "allLevels": "Alla nivåer",
    "noData": "Inga kurser hittades",
    "noTeacher": "Ingen lärare",
    "nextSession": "Nästa session:",
    "columns": {
      "title": "Titel",
      "level": "Nivå",
      "duration": "Varaktighet",
      "price": "Pris",
      "status": "Status",
      "nextSession": "Nästa session",
      "fill": "Fyllnad",
      "teachers": "Lärare"
    },
    "level": {
      "Basic": "Grundläggande",
      "Intermediate": "Mellannivå",
      "Expert": "Expert",
      "ExpertFinishes": "Expert — Ytskikt"
    },
    "status": {
      "Draft": "Utkast",
      "Published": "Publicerad",
      "Archived": "Arkiverad"
    },
    "sessionStatus": {
      "Scheduled": "Planerad",
      "Open": "Öppen",
      "Full": "Full",
      "Cancelled": "Inställd",
      "Completed": "Avslutad"
    },
    "form": {
      "title": "Titel",
      "titleRequired": "Titel krävs",
      "description": "Beskrivning",
      "level": "Nivå",
      "status": "Status",
      "durationMinutes": "Varaktighet (minuter)",
      "location": "Plats",
      "language": "Språk",
      "maxStudents": "Max studenter",
      "price": "Pris (EUR)"
    },
    "archive": {
      "title": "Arkivera kurs",
      "confirm": "Arkivera \"{{title}}\"?",
      "action": "Arkivera"
    },
    "sessions": {
      "title": "Sessioner",
      "empty": "Inga sessioner än",
      "noComing": "Inga kommande sessioner",
      "showPast": "Visa tidigare ({{count}})"
    },
    "session": {
      "createButton": "Lägg till session",
      "createTitle": "Lägg till session",
      "editTitle": "Redigera session",
      "date": "Datum",
      "startTime": "Starttid",
      "endTime": "Sluttid",
      "location": "Plats",
      "country": "Land",
      "availableSeats": "Tillgängliga platser",
      "status": "Status",
      "seats": "platser",
      "until": "till",
      "enrollments": "Anmälningar",
      "students": "Studenter",
      "noStudents": "Inga studenter anmälda",
      "addStudent": "Lägg till student",
      "edit": "Redigera session",
      "deleteTitle": "Ta bort session",
      "deleteConfirm": "Är du säker på att du vill ta bort denna session? Alla anmälningar kommer att tas bort.",
      "complete": "Avsluta",
      "reopen": "Återöppna"
    },
    "enroll": {
      "title": "Anmäl student",
      "button": "Anmäl",
      "action": "Anmäl",
      "search": "Sök studenter",
      "searchPlaceholder": "Skriv för att söka...",
      "student": "Student",
      "studentPlaceholder": "Välj student...",
      "noResults": "Inga studenter hittades",
      "noEnrollments": "Inga anmälningar än",
      "remove": "Avanmäl",
      "removeTitle": "Ta bort anmälan",
      "removeConfirm": "Ta bort {{name}} från denna session?",
      "columns": {
        "name": "Namn",
        "email": "E-post",
        "enrolledAt": "Anmäld den"
      }
    },
    "teachers": {
      "title": "Lärare",
      "add": "Lägg till lärare",
      "empty": "Ingen lärare tilldelad",
      "assign": "Tilldela",
      "removeTitle": "Ta bort lärare",
      "removeConfirm": "Ta bort {{name}} från denna kurs?",
      "select": "Välj lärare..."
    },
    "enrollmentStatus": {
      "Registered": "Anmäld",
      "Attended": "Närvarat",
      "Completed": "Avslutad",
      "Cancelled": "Avbokad"
    },
    "attendance": {
      "edit": "Redigera närvaro",
      "present": "Närvarande",
      "absent": "Frånvarande",
      "comment": "Kommentar",
      "commentTitle": "Lägg till kommentar",
      "commentPlaceholder": "Kommentar (valfritt)..."
    },
    "create": {
      "successTitle": "Kurs skapad",
      "successMessage": "Kursen har skapats.",
      "errorTitle": "Fel",
      "errorMessage": "Det gick inte att skapa kursen."
    }
  }
}